import React from 'react';
import * as XLSX from 'xlsx';
import config from "../../common/Config";
import { Button } from '@mui/material';
import '../../common/commonStyles.css';
import { postGetUsersList } from '../../../utils/usersApi';

const ExportUserList = ({ totalUsers, urlLink, status }) => {
  const token = localStorage.getItem('token');

  const exportUserList = async () => {
    const apiActivePdtUrl = `${config.API_URL}/${urlLink}`;

    try {
      const data = await postGetUsersList(apiActivePdtUrl, token, {
        draw: 1,
        start: 0,
        length: totalUsers || 10000,
        searchValue: '',
        status,
      });

      const rows = Array.isArray(data?.data) ? data.data : [];
      const filtered = status === undefined || status === null || status === ''
        ? rows
        : rows.filter((user) =>
            Number(status) === 1 ? user.active == '1' : user.active != '1'
          );

      const exportData = filtered.map(user => ({
        "User Name": user.username || '',
        "First Name": user.first_name || '',
        "Last Name": user.last_name || '', 
        Email: user.email || '',
        Company: user.company || '',
        "Roles" : user.roles || '',
        Status: user.active === '1' ? 'Active' : 'Inactive' 
      }));

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Active Products');

      // Get current date and time for the filename (e.g., '2024-11-07-14-30-45')
      const now = new Date();
      const formattedDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      const formattedTime = `${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
      const filename = `user-list-${formattedDate}-${formattedTime}.xlsx`;

      
      XLSX.writeFile(wb, filename);
    } catch {
    }
  };

  return (
    <Button
      variant="contained"
      className="button-variant-contained"
      onClick={exportUserList}
      sx={{ whiteSpace: "nowrap", flexShrink: 0 }}
    >
      Export Users
    </Button>
  );
};

export default ExportUserList;
